/**
 * Toaster — single fixed toast region driven by useToast.
 *
 * Mount once per page. Presentational only — useToast lives at the parent
 * and supplies `toast` and `dismiss`.
 */
import React from 'react';
import './Toaster.css';

export default function Toaster({ toast, onDismiss }) {
  // The region itself is always rendered so screen readers can pick up
  // updates, but the visual item only appears when there is a toast.
  return (
    <div
      className="offers-toaster"
      role="status"
      aria-live="polite"
      aria-atomic="true"
    >
      {toast && (
        <div
          className={`offers-toaster__item offers-toaster__item--${toast.kind || 'info'}`}
        >
          <span className="offers-toaster__message">{toast.message}</span>
          <button
            type="button"
            className="offers-toaster__close"
            onClick={onDismiss}
            aria-label="Dismiss notification"
          >
            ×
          </button>
        </div>
      )}
    </div>
  );
}
